// extracted by mini-css-extract-plugin
export default {"width":"styles_width__+OG6U","screenshot":"styles_screenshot__M1Xhg","bold":"styles_bold__Vyi5-","nextTitle":"styles_nextTitle__GbNS-"};